(() => {
  const initialize = () => {
    document.querySelectorAll('[data-atlas-sticky-purchase]').forEach((bar) => {
      if (bar.dataset.atlasStickyPurchaseReady === 'true') return;

      bar.dataset.atlasStickyPurchaseReady = 'true';
      const sectionId = bar.dataset.atlasStickyPurchase;
      const button = bar.querySelector('.atlas-sticky-purchase__button');
      const price = bar.querySelector('[data-atlas-sticky-price]');
      let purchaseButton = null;
      let purchaseObserver = null;
      let priceObserver = null;
      let discoveryObserver = null;
      let purchaseInViewport = true;
      let restoreFocusOnClose = false;

      const getRenderedPrice = () => {
        const source = document.querySelector(`#price-${CSS.escape(sectionId)} .price-item-last, #price-${CSS.escape(sectionId)} .price-item-regular`);
        if (!source) return '';

        const cleanPrice = source.cloneNode(true);
        cleanPrice.querySelectorAll('.sup').forEach((suffix) => suffix.remove());
        return cleanPrice.textContent.trim().replace(/\s+[A-Z]{3}$/, '');
      };

      const syncPersonaliserLabel = (nextPrice) => {
        const productPage = document.querySelector(`#ProductPage-${CSS.escape(sectionId)}`);
        const initialLabel = productPage?.dataset.atlasCustomiseLabel;
        if (!purchaseButton || !initialLabel || !nextPrice) return;

        const separator = initialLabel.includes('—') ? '—' : '-';
        const labelPrefix = initialLabel.split(separator)[0].trim();
        const nextLabel = `${labelPrefix} ${separator} ${nextPrice}`;

        purchaseButton.textContent = nextLabel;
        purchaseButton.setAttribute('aria-label', nextLabel);
      };

      const setVisible = (visible) => {
        const canShow = visible && !document.body.classList.contains('atlas-overlay-active');
        bar.classList.toggle('is-visible', canShow);
        bar.setAttribute('aria-hidden', String(!canShow));
        button.tabIndex = canShow ? 0 : -1;
        document.body.classList.toggle('atlas-sticky-purchase-active', canShow);
      };

      const syncPrice = () => {
        const nextPrice = getRenderedPrice();
        if (nextPrice && price.textContent.trim() !== nextPrice) price.textContent = nextPrice;
        syncPersonaliserLabel(nextPrice);
      };

      const watchPrice = () => {
        const priceSource = document.querySelector(`#price-${CSS.escape(sectionId)}`);
        if (!priceSource) return;

        priceObserver?.disconnect();
        priceObserver = new MutationObserver(syncPrice);
        priceObserver.observe(priceSource, { childList: true, characterData: true, subtree: true });
      };

      const watchPurchaseButton = () => {
        const nextButton = document.querySelector(`#Product-${CSS.escape(sectionId)} .pplr-c-button`);
        if (!nextButton || nextButton === purchaseButton) return;

        purchaseButton = nextButton;
        purchaseObserver?.disconnect();
        purchaseObserver = new IntersectionObserver(([entry]) => {
          purchaseInViewport = entry.isIntersecting;
          setVisible(!purchaseInViewport);
        }, { threshold: 0.01 });
        purchaseObserver.observe(purchaseButton);

        watchPrice();

        discoveryObserver?.disconnect();
        syncPrice();
      };

      const handleVariantChange = () => {
        window.requestAnimationFrame(() => {
          watchPrice();
          syncPrice();
        });
      };

      document.addEventListener('product:variant-change', handleVariantChange);

      button.addEventListener('click', () => {
        if (!purchaseButton?.isConnected) watchPurchaseButton();
        restoreFocusOnClose = true;
        window.atlasPersonaliserOpener = button;
        purchaseButton?.click();
      });

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        button.click();
      });

      document.addEventListener('click', (event) => {
        if (!restoreFocusOnClose || !event.target.closest?.('.pplr_close')) return;
        restoreFocusOnClose = false;
        window.setTimeout(() => {
          if (button.isConnected) button.focus({ preventScroll: true });
        }, 900);
      }, true);

      document.addEventListener('click', (event) => {
        if (event.target.closest?.('.p_a_t_c')) restoreFocusOnClose = false;
      }, true);

      const overlayObserver = new MutationObserver(() => {
        setVisible(!purchaseInViewport);
      });

      overlayObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
      });

      watchPurchaseButton();
      if (!purchaseButton) {
        const productRoot = document.querySelector(`#Product-${CSS.escape(sectionId)}`);
        if (productRoot) {
          discoveryObserver = new MutationObserver(watchPurchaseButton);
          discoveryObserver.observe(productRoot, { childList: true, subtree: true });
        }
      }

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId !== sectionId) return;
        purchaseObserver?.disconnect();
        priceObserver?.disconnect();
        discoveryObserver?.disconnect();
        overlayObserver.disconnect();
        document.removeEventListener('product:variant-change', handleVariantChange);
        document.body.classList.remove('atlas-sticky-purchase-active');
      }, { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
